import { RadioButton } from "features/components/inputs/KroRadioButtonGroup";
import { FormApi, ReactFormApi } from "@tanstack/react-form";
import { WithdrawalOptionsForm } from "./withdrawalOptions";
import { WithdrawalType } from "features/dashboard/domain/enums/withdrawalType.enum";

export const WithdrawalTile = ({
  name,
  description,
  form,
  withdrawalType,
  isSelected,
  disabled = false,
}: {
  name: string;
  description: string;
  form: FormApi<WithdrawalOptionsForm> & ReactFormApi<WithdrawalOptionsForm>;
  withdrawalType: WithdrawalType;
  isSelected: boolean;
  disabled?: boolean;
}) => {
  return (
    <div
      onClick={() => {
        if (!disabled) {
          form.setFieldValue("withdrawalType", withdrawalType);
        }
      }}
      className={`flex max-h-full min-h-[72px] w-full flex-row rounded-[8px] p-4 ${
        disabled
          ? "cursor-not-allowed bg-gray-200 opacity-60"
          : "cursor-pointer bg-[#F5F5F5]"
      }`}
    >
      <div className="flex flex-1 flex-col gap-[4px]">
        <p
          className={`font-dm-sans text-[16px] font-semibold leading-[100%] tracking-[-3%] ${disabled ? "text-gray-500" : "text-[#131313]"}`}
        >
          {name}
        </p>
        <p
          className={`font-dm-sans text-[14px] font-normal leading-[140%] tracking-[0%] ${disabled ? "text-gray-500" : "text-strong-950"}`}
        >
          {description}
        </p>
      </div>
      <div className="flex-5 flex items-center justify-center">
        <form.Field
          name="withdrawalType"
          children={(field) => (
            <RadioButton
              id={`${field.name}-${withdrawalType}`}
              name={field.name}
              value={withdrawalType}
              label=""
              onToggle={() => {
                if (!disabled) {
                  form.setFieldValue("withdrawalType", withdrawalType);
                }
              }}
              inputClassName={`group-radio-input ${disabled ? "opacity-50" : ""}`}
              labelClassName="group-radio-label"
              labelField=""
              useRoundChecked={true}
              isChecked={field.state.value === withdrawalType}
            />
          )}
        />
      </div>
    </div>
  );
};
